import axios from "@/libs/api.request.js";

// 获取手机验证码
export const getPhoneCode = (data) => axios.request({ url: `/platform-cloud-order/order/mobileCode`, data, requireKsFormSign: true });

// 预创建订单
export const preCreateKsFormOrder = (data) => axios.request({ url: `/platform-cloud-order/order/preCreate`, data, requireKsFormSign: true });

// 获取商品列表 -- 弃用
export const getKsFormGoodsList = (data) => axios.request({ url: `/platform-cloud-order/goods/list`, data, requireKsFormSign: true });

// 获取商品列表
export const getKsFormGoodsListV2 = (data) => axios.request({ url: `/platform-cloud-order/order/ksFormGoodsIdsList`, data, requireKsFormSign: true });

// 下单
export const createKsFormOrder = (data) => axios.request({ url: `/platform-cloud-order/order/ksFormPayOrder`, data, requireKsFormSign: true });

// 检查订单支付结果
export const checkOrderPayResult = (data) => axios.request({ url: `/platform-cloud-order/order/checkOrderStatus`, data, requireKsFormSign: true });

// 查询用户奖励信息接口
export const getUserRewardInfo = (data) => axios.request({ url: `/platform-cloud-order/order/ksFormReward`, data, requireKsFormSign: true });
